import React from "react";
import {
  Box,
  Typography,
  Avatar,
  IconButton,
  Link,
  useTheme,
} from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import CommonLabel from "../../../components/label";
import BrandLogo from "../../../components/brand-logo";
import RoundedTextBox from "../../../components/TextBoxes/rounded-text-box";
import CommonTextBox from "../../../components/TextBoxes/common-text-box";
import CommonButton from "../../../components/Buttons/common-button";

const BrandHeader = ({
  brandDetail,
  //   brandName = "NYKAA",
  //   brandUrl = "https://www.nykaa.com",
  //   backgroundColor = "#ff2d7a",
  // brandName
  //   logoText = "N",
  //   logoSrc = "",
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        overflow: "hidden",
        maxHeight:'170px'
      }}
    >
      {/* Top Banner */}
      <Box
        sx={{
          background: "linear-gradient(180deg, #FF68A2, #FC2779)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height:'75px', 
          
        }}
      >
        <Box sx={{ transform: "translateY(55px)" }}>
          <BrandLogo img_url={brandDetail?.brand_image} />
        </Box>
      </Box>

      {/* Content Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          px: 2,
          pb: 4,
          height: "170px",
          transform:`translateY(60px)`
        }}
      >
        {/* Overlapping Logo */}
        {/* <Avatar
          src={brandDetail?.brand_image}
          alt={brandDetail?.brand_name}
          sx={{
            width: { xs: 72, sm: 82, md: 92 },
            height: { xs: 72, sm: 82, md: 92 },
            mt: { xs: "-36px", sm: "-41px", md: "-46px" },
            border: "4px solid white",
            boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
            bgcolor: brandDetail?.brand_color,
            fontSize: { xs: 24, sm: 28, md: 32 },
            fontWeight: 700,
          }}
        >
          {!brandDetail?.brand_image ? brandDetail?.brand_name : null}
        </Avatar> */}

        {/* Brand Name + URL */}
        <Box
          sx={{
            mt: 1.5,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <CommonLabel
            variant="h6"
            sx={{
              fontWeight: 700,
              color: theme.palette.text.primary,
              textAlign: "center",
              fontSize: { xs: "1rem", sm: "1.1rem", md: "1.2rem" },
            }}
          >
            {brandDetail?.brand_name}
          </CommonLabel>

          <IconButton
            component={Link}
            href={brandDetail?.brand_offical_url}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            sx={{
              color: theme.palette.primary.main,
              p: 0.5,
            }}
          >
            <LinkIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* <Box sx={{py:'10px'}}>
          <CommonLabel variant={"caption"} sx={{fontSize:'1rem',mx:'10px'}}>10,000 followers</CommonLabel>
          <CommonButton text="Follow" style="black"></CommonButton>
        </Box> */}
        <Box>
          <Box>
         
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default BrandHeader;
